import './demandplanning.component.scss';
import { IMAGES_REPO } from '../../../static-resources';
const DemandPlanningComponent = () => {
  return (
    <>
      <div className="menusub-title">Prescriptive Analysis</div>
      <ul className="megamenu-components">
        <li>
          <div className="d-flex navsubmenuitem">
            <div className="w-20">
              <div className="sideicon">
                <img src={IMAGES_REPO.RefreshIcon} alt="" />
              </div>
            </div>
            <div className="w-80">
              <div className="navmenuitem ps-3">
                <h6>Rev/Profit/Trade Optimization</h6>
                <p>Coming Soon</p>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div className="d-flex navsubmenuitem">
            <div className="w-20">
              <div className="sideicon">
                <img src={IMAGES_REPO.CalenderDate} alt="" />
              </div>
            </div>
            <div className="w-80">
              <div className="navmenuitem ps-3">
                <h6>Week of Month Optimization</h6>
                <p>Coming Soon</p>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div className="d-flex navsubmenuitem">
            <div className="w-20">
              <div className="sideicon">
                <img src={IMAGES_REPO.CurrencyDollarCircle} alt="" />
              </div>
            </div>
            <div className="w-80">
              <div className="navmenuitem ps-3">
                <h6> Price Threshold Optimization</h6>
                <p>Coming Soon</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </>
  );
};
export default DemandPlanningComponent;
